import * as React from "react";

const IconMoreInactive: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#CCC" fillRule="evenodd" d="M6 0v4h4v2H6v4H4V6H0V4h4V0h2z"/></svg>;
};

export default React.memo(IconMoreInactive);
